import React from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { Route, Routes } from 'react-router-dom';
import List from './pages/List';
import Edit from './pages/Edit';

const ProgramsComponent = ({ ...props }) => {
    return (<Routes>
            <Route
                index
                element={<List />}
            />
            <Route
                path="/edit"
                element={<Edit />}
            />
        </Routes>);
};

ProgramsComponent.displayName = 'Programs';

const Programs = (props) => {
    return (
        <ErrorWrapper>
            <ProgramsComponent data-id='Programs-cpn' {...props} />
        </ErrorWrapper>
    );
};

export default Programs;